import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import GrowthBars from "@/components/GrowthBars";
import { WHATSAPP_LINK } from "@/lib/constants";

const CTABand = ({
    title = (
        <>
            O próximo movimento <span className="text-emerald-400">começa com uma conversa.</span>
        </>
    ),
    text = "Cada empresa tem desafios, prioridades e oportunidades diferentes. Vamos entender o seu cenário e construir uma proposta adequada à sua realidade.",
}) => (
    <section className="bg-slate-50 px-6 pb-24 md:px-10 md:pb-32" data-testid="cta-band">
        <div className="mx-auto max-w-7xl">
            <Reveal>
                <div className="grain-overlay relative overflow-hidden rounded-[2rem] bg-navy-deep p-10 md:p-16 lg:p-20">
                    <GrowthBars className="pointer-events-none absolute -right-6 bottom-0 w-64 opacity-15 md:w-80" />
                    <div className="relative max-w-2xl">
                        <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-emerald-400">
                            Vamos conversar
                        </p>
                        <h2 className="mt-5 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl lg:leading-[1.08]">
                            {title}
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-slate-300 sm:text-lg">{text}</p>
                        <div className="mt-9 flex flex-col gap-4 sm:flex-row">
                            <Link
                                to="/contato"
                                data-testid="cta-band-diagnostico"
                                className="inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-8 py-4 font-semibold text-white transition-colors duration-200 hover:bg-emerald-600"
                            >
                                Solicite um diagnóstico
                                <ArrowUpRight size={18} />
                            </Link>
                            <a
                                href={WHATSAPP_LINK}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="cta-band-whatsapp"
                                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-8 py-4 font-semibold text-white transition-colors duration-200 hover:bg-white/10"
                            >
                                Chamar no WhatsApp
                            </a>
                        </div>
                    </div>
                </div>
            </Reveal>
        </div>
    </section>
);

export default CTABand;
